// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { GroundingsListComponent } from 'src/app/modules/groundings/pages/groundings-list/groundings-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: GroundingsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class GroundingsRoutingModule { }
